"use client";
import appConfig from "@/configs/app-config";
import { SAKA_COOKIE_NAMES } from "@/constants/cookieNames";
import { useAuth } from "@/contexts/AuthContext";
import { sendGTMEvent } from "@next/third-parties/google";
import Cookies from "js-cookie";
import { usePathname } from "next/navigation";
import { useEffect } from "react";

const VirtualPvEvent = ({ pageType, data = {}, pageUrl }) => {
  const pathname = usePathname();
  const { session, loading } = useAuth();

  useEffect(() => {
    if (loading) return;

    sendGTMEvent({
      event: "virtual_pv",
      environment:
        process.env.NEXT_PUBLIC_BASE_URL === "https://www.turna.com"
          ? "prod"
          : process.env.NEXT_PUBLIC_BASE_URL === "https://stage.turna.com"
            ? "stage"
            : process.env.NEXT_PUBLIC_BASE_URL === "https://test.turna.com"
              ? "test"
              : "local",
      virtual_page_url: pageUrl || pathname,
      turna_device_id: Cookies.get(SAKA_COOKIE_NAMES.DEVICE_ID) || "",
      page_type: pageType,
      website_version: appConfig.WEBSITE_VERSION,
      digital_platform_country: appConfig.COUNTRY_CODE,
      ...(data && { ...data }),

      language: session?.LanguageCode.toUpperCase(),
      turna_session_id: session?.SessionId,

      ...(session?.IsLoggedIn
        ? {
            user_type: "member",
            user_hashed_email: session?.HashedEmail ?? null,
            user_hashed_phone: session?.HashedPhoneNumber ?? null,
            // user_mail: session?.Email,
            // user_phone:
            //   session?.MobilePhoneNumberPrefix + session?.MobilePhoneNumber,
            user_turna_points: session?.UserPointTotal?.TotalPoint,
            first_time_purchaser: session?.FirstTimePurchaser || null,
            user_promotions_consent: session?.IsMailingAllowed || false,
            user_id: session?.UserId?.toString() ?? "",
          }
        : {
            user_type: "guest",
            guest_user_hashed_email: null,
            guest_user_hashed_phone: null,
            user_promotions_consent: false,
            user_id: "",
          }),
    });
  }, [session, pathname]);

  return null;
};

export default VirtualPvEvent;
